import { AlertMessage } from '../../../../../../../shared/AlertMessage';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  container: Element | DocumentFragment;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmRejectAnswerModal = ({
  container,
  isOpen,
  onCancel,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <AlertMessage.Root
      isOpen={isOpen}
      onClose={onClose}
      container={container}
      disableScroll
      title="Rejeitar Proposta?"
      footer={
        <AlertMessage.Footer>
          <AlertMessage.CancelButton onClick={onCancel}>
            Revisar
          </AlertMessage.CancelButton>
          <AlertMessage.ConfirmButton onClick={onConfirm} />
        </AlertMessage.Footer>
      }
    >
      <AlertMessage.Body>
        Deseja rejeitar essa proposta? Essa ação é permanente.
      </AlertMessage.Body>
    </AlertMessage.Root>
  );
};
